export default __webpack_public_path__ + "static/media/logo-small.a2d3e5cd.svg";